{
  "journalAudit.action.org.invitation.grant_added": "Attribution ajoutée à une invitation",
  "journalAudit.action.org.invitation.grant_removed": "Attribution retirée d’une invitation",
  "v8e.code.ALREADY_MEMBER": "La personne invitée en est déjà membre.",
  "v8e.code.CONFLIT_CONCURRENT": "L’invitation a changé entre-temps : elle vient d’être relue, vérifiez puis recommencez.",
  "v8e.code.INVITATION_NOT_RENEWABLE": "Invitation déjà acceptée ou révoquée : aucun nouveau lien.",
  "v8e.code.INVITATION_NOT_REVOCABLE": "Invitation déjà acceptée ou révoquée.",
  "v8e.code.LAST_OWNER": "C’est le dernier propriétaire actif du projet : nommez d’abord un autre propriétaire.",
  "v8e.code.MEMBERSHIP_NOT_FOUND": "Cette personne n’en est déjà plus membre.",
  "v8e.code.OWNERSHIP_TRANSFER_REQUIRED": "Cette personne est propriétaire de l’espace : transférez d’abord la propriété.",
  "v8e.code.PROFIL_INCONNU": "Ce profil est inconnu ou n’est pas publié.",
  "v8e.code.PROFIL_NIVEAU_INCOMPATIBLE": "Ce profil n’est pas du niveau de l’espace choisi.",
  "v8e.code.PROGRAM_LAST_OWNER": "C’est le dernier propriétaire actif du programme : nommez d’abord un autre propriétaire.",
  "v8e.code.V8E_ATTRIBUTIONS_TROP_NOMBREUSES": "Une invitation compte 50 projets ou programmes au plus.",
  "v8e.code.V8E_ATTRIBUTION_ABSENTE": "Cette attribution ne figure pas (ou plus) dans l’invitation.",
  "v8e.code.V8E_ATTRIBUTION_DEJA_PRESENTE": "Ce projet ou ce programme figure déjà dans l’invitation.",
  "v8e.code.V8E_INVITATION_NON_EN_ATTENTE": "Cette invitation n’est plus en attente (acceptée, révoquée ou expirée) : ses attributions sont figées.",
  "v8e.code.WORKSPACE_ARCHIVED": "Projet archivé : il est en lecture seule.",
  "v8e.invitations.action.org.invitation.accepted": "Invitation acceptée",
  "v8e.invitations.action.org.invitation.created": "Invitation envoyée",
  "v8e.invitations.action.org.invitation.grant_added": "Attribution ajoutée",
  "v8e.invitations.action.org.invitation.grant_removed": "Attribution retirée",
  "v8e.invitations.action.org.invitation.renewed": "Nouveau lien envoyé",
  "v8e.invitations.action.org.invitation.resent": "Courriel renvoyé",
  "v8e.invitations.action.org.invitation.revoked": "Invitation révoquée",
  "v8e.invitations.ajout.ajouter_programme": "Ajouter l’attribution au programme",
  "v8e.invitations.ajout.ajouter_projet": "Ajouter l’attribution au projet",
  "v8e.invitations.ajout.archive": "{{nom}} (archivé, lecture seule)",
  "v8e.invitations.ajout.choisir": "Choisir…",
  "v8e.invitations.ajout.espace_programme": "Programme",
  "v8e.invitations.ajout.espace_projet": "Projet",
  "v8e.invitations.ajout.espaces_programme": "les programmes",
  "v8e.invitations.ajout.espaces_projet": "les projets",
  "v8e.invitations.ajout.invitation_visee": "Invitation de {{email}} — {{etat}}",
  "v8e.invitations.ajout.profils": "les profils publiés",
  "v8e.invitations.ajout.profils_programme": "Profils sur le programme",
  "v8e.invitations.ajout.profils_projet": "Profils sur le projet",
  "v8e.invitations.ajout.profils_refuses_k3": "La liste des profils publiés demande le droit de voir les profils de l’organisation : l’ajout reste fermé.",
  "v8e.invitations.ajout.type": "Type",
  "v8e.invitations.appartenance.absente": "Cette appartenance est introuvable ou déjà retirée.",
  "v8e.invitations.appartenance.dernier_proprietaire": "Dernier propriétaire actif : transférez d’abord la propriété.",
  "v8e.invitations.appartenance.effet_acces": "Son accès à cet espace est révoqué immédiatement, avec ses profils et ses droits isolés sur l’espace.",
  "v8e.invitations.appartenance.effet_compte": "Son compte reste actif dans l’organisation.",
  "v8e.invitations.appartenance.effets": "les effets du retrait",
  "v8e.invitations.appartenance.effets_programme_k5": "Aucun effet de travail n’est décrit pour un programme.",
  "v8e.invitations.appartenance.effets_projet": "Travail assigné : {{travail}} ; désignations : {{designations}} ; équipes : {{equipes}}.",
  "v8e.invitations.appartenance.personne": "la personne",
  "v8e.invitations.appartenance.retirer_programme": "Retirer du programme",
  "v8e.invitations.appartenance.retirer_projet": "Retirer du projet",
  "v8e.invitations.appartenance.visee": "Retirer {{personne}} de {{nom}} ({{niveau}}).",
  "v8e.invitations.fiche.adresse": "Adresse",
  "v8e.invitations.fiche.ajouter_attribution": "Ajouter un projet ou un programme",
  "v8e.invitations.fiche.attributions": "Projets et programmes",
  "v8e.invitations.fiche.aucune_attribution": "Aucun projet ni programme dans cette invitation.",
  "v8e.invitations.fiche.avertissement_administrateur": "Cette personne administrera l’organisation dès l’acceptation.",
  "v8e.invitations.fiche.copie": "Lien copié.",
  "v8e.invitations.fiche.copier": "Copier le lien",
  "v8e.invitations.fiche.courriel_envoye": "Le lien a été envoyé par courriel.",
  "v8e.invitations.fiche.echeance": "Expire le",
  "v8e.invitations.fiche.etat": "État",
  "v8e.invitations.fiche.historique": "Historique de l’invitation",
  "v8e.invitations.fiche.invitation": "l’invitation",
  "v8e.invitations.fiche.lien": "Lien d’invitation",
  "v8e.invitations.fiche.lien_masque": "Le lien n’est plus affichable : créez un nouveau lien si besoin.",
  "v8e.invitations.fiche.lien_precedent_invalide": "Le lien précédent ne fonctionne plus.",
  "v8e.invitations.fiche.lien_une_fois": "Ce lien n’est montré qu’une seule fois : copiez-le maintenant.",
  "v8e.invitations.fiche.membre_simple": "Aucun profil d’organisation : membre simple.",
  "v8e.invitations.fiche.mode": "Envoi",
  "v8e.invitations.fiche.mode_courriel": "Par courriel",
  "v8e.invitations.fiche.mode_lien": "Lien à usage unique",
  "v8e.invitations.fiche.motif": "Motif de la révocation (facultatif)",
  "v8e.invitations.fiche.nouveau_lien": "Créer un nouveau lien",
  "v8e.invitations.fiche.profil_propose": "Profil d’organisation proposé",
  "v8e.invitations.fiche.retirer_attribution": "Retirer {{nom}}",
  "v8e.invitations.fiche.retour_membres": "Retour aux membres",
  "v8e.invitations.fiche.revocation": "Révocation",
  "v8e.invitations.fiche.revoquee": "Invitation révoquée.",
  "v8e.invitations.fiche.revoquer": "Révoquer l’invitation",
  "v8e.invitations.fiche.revoquer_consequence_compte": "Le compte jamais activé est supprimé avec ses appartenances.",
  "v8e.invitations.fiche.revoquer_consequence_lien": "Le lien d’invitation cessera de fonctionner.",
  "v8e.invitations.fiche.revoquer_titre": "Révoquer cette invitation ?",
  "v8e.invitations.fiche.sans_profil": "sans profil",
  "v8e.invitations.niveau.programme": "Programme",
  "v8e.invitations.niveau.projet": "Projet",
  "v8e.invitations.retrait.attribution_visee": "Retirer {{nom}} ({{niveau}}, {{profils}}) de l’invitation de {{email}}.",
  "v8e.invitations.retrait.retirer_programme": "Retirer du programme",
  "v8e.invitations.retrait.retirer_projet": "Retirer du projet",
  "v8e.invitations.statut.acceptee": "Acceptée",
  "v8e.invitations.statut.en_attente": "En attente",
  "v8e.invitations.statut.expiree": "Expirée",
  "v8e.invitations.statut.revoquee": "Révoquée"
}
